import React, { useCallback, useEffect, useState } from "react";
import DownloadPageComponent from "./utils/DownloadPageComponent";
import GlobalFilterComponent from "./utils/GlobalFilterComponent";
import DateFilter from "./utils/DateFilter";
import { useLocation } from "react-router-dom";
import { DateParentFilterType, reportListObject } from "../types/types";
import { GenericPopUp } from "../../../components/popup/genericPopUp";
import { popupType } from "../../../types/types";
import "./DownloadPage.css";
import GenericFilters from "../../../components/genericFilters/genericFilters";
import { useReportGlobalFilters } from "../../../providers/ReportGlobalFiltersProvider";
import store from "../../../stateManagement/store";
import { Box, Tab, Tabs } from "@mui/material";

const DownloadPage = (props: reportListObject | {}) => {
  const location = useLocation();
  const reportData = ((props as reportListObject)?.id ? props : location.state) as reportListObject;
  console.log("reportData",reportData)
  const [startDateForAttribute, setStartDateForAttribute] =
    useState<string>("");
  const [endDateForAttribute, setEndDateForAttribute] = useState<string>("");
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState<string>("");
  const [resetFiltersFlag, setResetFiltersFlag] = useState<boolean>(false);
  const [yearForAttribute, setYearForAttribute] = useState<string>("");
  const [periodForAttribute, setPeriodForAttribute] = useState<string>("");
  // const [quarterForAttribute, setQuarterForAttribute] = useState<string>(""); 
  const [selectedLiveFilter, setSelectedLiveFilter] = useState<string>("");
  const { reportGlobalFiltersState, setReportGlobalFiltersState } = useReportGlobalFilters();
  const [parentFilterIndex, setParentFilterIndex] = useState(0);
  const openPopup = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);

  useEffect(() => {
    if ((startDateForAttribute && endDateForAttribute) || Object.keys(reportGlobalFiltersState).length) {
      openPopup("Filter applied", "Success");
    }
  }, [startDateForAttribute, endDateForAttribute,reportGlobalFiltersState]);

  function genericFilterApplyClick() {
    setReportGlobalFiltersState(store?.getState()?.genericFilter)
    openPopup("Filter applied", "Success");
  }
  return (
    <div className="report-download-page-container">
      <div className="reset-button-reports">
        {reportData.parentFilter?.length && (
          <Box className="parent-filter-container" sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs variant="fullWidth" centered value={parentFilterIndex} onChange={(event,val)=>{
              setParentFilterIndex(val)
            }} aria-label="basic tabs example">
              {reportData.parentFilter.map(parentFilterObject=>(
                <Tab key={parentFilterObject.id} label={parentFilterObject.name} />
              ))}
            </Tabs>
          </Box>
        )}
        {reportData.globalFilters?.length && (
          <Box className="generic-filter-container">
            <GenericFilters resetFiltersFlag={resetFiltersFlag} onApplyClick={reportData.filter ? undefined : genericFilterApplyClick} filterOptions={reportData.globalFilters} hideResetButton={Boolean(reportData.filter)} />
          </Box>
        )}
        {reportData.filter && (
          <div className="Date-filter">
            <DateFilter
              allowFutureDate={reportData?.report?.allowFutureDate}
              report={reportData.report}
              id={reportData.id}
              type={reportData.type}
              name={reportData.name}
              filter={reportData.filter}
              selectedParentFilter = {(reportData.parentFilter && reportData.parentFilter.length > parentFilterIndex) ? reportData.parentFilter[parentFilterIndex] : undefined}
              setStartDateForAttribute={setStartDateForAttribute}
              setEndDateForAttribute={setEndDateForAttribute}
              startDateForAttribute={startDateForAttribute}
              endDateForAttribute={endDateForAttribute}
              setResetFiltersFlag={reportData.globalFilters?.length ? setResetFiltersFlag : undefined}
              setYearForAttribute={setYearForAttribute}
              setPeriodForAttribute={setPeriodForAttribute} 
              selectedLiveFilter={selectedLiveFilter}
              setSelectedLiveFilter={setSelectedLiveFilter}
              // setQuarterForAttribute={setQuarterForAttribute} 
            />
          </div>
        )}
        {/* <div className='global-filter'>
                <GlobalFilterComponent/>
            </div> */}
      </div>
      <div className="download-page">
        <DownloadPageComponent
          report={reportData.report}
          id={reportData.id}
          type={reportData.type}
          name={reportData.name}
          filter={reportData.filter}
          setShowReportModal={reportData.setShowReportModal}
          selectedParentFilter = {(reportData.parentFilter && reportData.parentFilter.length > parentFilterIndex) ? reportData.parentFilter[parentFilterIndex] : undefined}
          setStartDateForAttribute={setStartDateForAttribute}
          setEndDateForAttribute={setEndDateForAttribute}
          startDateForAttribute={startDateForAttribute}
          endDateForAttribute={endDateForAttribute}
          batchDownload={reportData.batchDownload}
          yearForAttribute={yearForAttribute}
          periodForAttribute={periodForAttribute}
          selectedLiveFilter={selectedLiveFilter}
          // quarterForAttribute={quarterForAttribute}
        />
        <GenericPopUp
          message={genericMessage}
          type={popupType}
          openGenericModal={openGenericModal}
          setOpenGenericModal={setOpenGenericModal}
        />
      </div>
    </div>
  );
};
export default DownloadPage;
